import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import AutoComplete from '../Common/AutoComplete';
import ComplianceStore from '../../stores/ComplianceStore';
import { searchCompliance } from '../../actions/ComplianceActionCreator';
import MenuItem from 'material-ui/MenuItem';

class SelectCompliance extends Component {

    componentDidMount() {
        this.onUpdate = this.onUpdate.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    render() {
        const { searchText, items } = this.state;
        const data = items && items.map(({id, name}) => ({
            id,
            text: name,
            value: <MenuItem key={id} value={id} primaryText={name} />
        }));

        return (
            <AutoComplete
                searchText={searchText}
                floatingLabelText={this.props.label}
                maxSearchResults={5}
                dataSource={data}
                onUpdateInput={this.onUpdate}
                onNewRequest={this.onSelect}
                fullWidth={true}
            />
        );
    }

    onUpdate(input) {
        this.timeout && clearTimeout(this.timeout);
        if (input !== undefined && input.length >= 2) {
            this.timeout = setTimeout(() => {
                searchCompliance(input);
            }, 500);
        }
        this.props.onUpdate && this.props.onUpdate(input);
        this.setState({searchText: input || ''});
    }

    onSelect({id, text}) {
        this.props.onSelect(text, id);
        if (this.props.clearOnSelect) {
            this.setState({searchText: ''});
        }
    }
}

SelectCompliance.getStores = () => ([ComplianceStore]);
SelectCompliance.calculateState = (prevState, {defaultValue = ''}) => {
    const searchText = (prevState && prevState.searchText) || defaultValue;
    return {
        searchText,
        items: ComplianceStore.searchByName(searchText) || []
    };
};

SelectCompliance.propTypes = {
    clearOnSelect: PropTypes.bool,
    defaultValue: PropTypes.string,
    label: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onUpdate: PropTypes.func
};

SelectCompliance.defaultProps = {
    clearOnSelect: true,
    label: 'Add compliance',
    maxSearchResults: 5,
};

export default Container.create(SelectCompliance, {withProps: true});
